module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('aside', {
    staticClass: "main-sidebar"
  }, [_c('section', {
    staticClass: "sidebar"
  }, [_c('form', {
    staticClass: "sidebar-form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_vm._m(0)]), _vm._v(" "), _c('sidebar-menu')], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    staticClass: "search form-control",
    attrs: {
      "type": "text",
      "name": "search",
      "id": "search",
      "data-toggle": "hideseek",
      "p": "",
      "laceholder": "Search Menus",
      "data-list": ".sidebar-menu"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-flat",
    attrs: {
      "type": "submit",
      "name": "search",
      "id": "search-btn"
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-351b5566"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Sidebar.vue
// module id = 620
// module chunks = 1